import React from 'react'
import { Grid, Icon, Card } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Button } from 'semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { singleLineText } from '../../../../common/RegexValidation';
import { source } from 'react-aim';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Tags Card');
    }
})

class PracticeViewPaneTags extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tags: props.tags ? props.tags : []
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.props.tags !== newProps.tags) {
            this.setState({ tags: newProps.tags })
        }
    }

    addTags = (e, data) => {
        let tagsToLowerCase = String(this.state.tags).toLowerCase().split(",");

        if ((tagsToLowerCase.indexOf(this.state.setTags.toLowerCase()) === -1)) {
            this.state.tags.push(this.state.setTags);
            this.props.onHandleTag(this.state.tags);
            this.setState({ setTags: '' });
            // this.resetForm();
        } else {
            toastr.error('Message', 'Tag already exists.')
        }
    }
    resetForm() {
        document.getElementById("tagForm").reset();
    }
    removeTag(tag) {
        let message = <div className="confirmMessage">
            <h3>Delete Tag</h3>
            <label>{tag}</label>
            <p>Are you sure that you wish to delete this tag?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let index = this.state.tags.indexOf(tag);
                if (index > -1) {
                    this.state.tags.splice(index, 1)
                    this.props.onHandleTag(this.state.tags)
                }
            }
        });
    }

    handleKeyDown = e => {
        if (e.key === " ") {
            e.preventDefault();
        }
    };

    render() {

        const errorLabel = <div className="customErrorLabel" />;

        return (
            <div>
                <Grid>
                    <Grid.Row>
                        <div className="tagsInput">
                            {this.props.editAccess && <div>
                                <div style={{ margin: "0 0 3px 0" }}>Tags</div>
                                <div class="ui action input">
                                    <input
                                        onKeyDown={this.handleKeyDown}
                                        type="text"
                                        name="tag"
                                        value={this.state.setTags}
                                        placeholder="Enter"
                                        onChange={(e) => this.setState({ setTags: e.target.value })}
                                        id="tag"
                                        required={this.props.module === "playbook"}
                                    />
                                    <button
                                        style={{ height: "30px" }}
                                        class="ui icon button"
                                        disabled={this.state.setTags == undefined || this.state.setTags === ''}
                                        onClick={(e, data) => this.addTags(e, data)}>
                                        <i class="plus icon"></i>
                                    </button>
                                </div>
                                {/* <input
                                    
                                    name="tag"
                                    value={this.state.setTags}
                                    placeholder="Enter"
                                    onChange={(e) => this.setState({ setTags: e.target.value })}
                                    id="tag"
                                    required={this.props.module === "playbook"}
                                />
                                <Button
                                   
                                    onClick={(e, data) => this.addTags(e, data)} 
                                    id="submit" className='add-tag' >
                                    <Icon name="plus" />
                                </Button> */}
                            </div>
                            }
                            <div style={{ 'margin': '15px 0px 0px 5px' }}>
                                <Card.Group>
                                    {this.state.tags &&
                                        this.state.tags.length ?
                                        this.state.tags.map((tag, i) => {
                                            return (<Card key={i}
                                                className={`${this.props.editAccess ? "tagsCard tagPad" : "tagsCard"}`} >
                                                <Card.Content>
                                                    {this.props.editAccess && <Icon
                                                        className="trashImage trash-color"
                                                        style={{ "cursor": "pointer" }}
                                                        floated='right'
                                                        name="trash alternate"
                                                        onClick={() => this.removeTag(tag)} />}
                                                    <Card.Meta >{tag}</Card.Meta>
                                                </Card.Content>
                                            </Card>)
                                        }) : this.props.module === "playbook" ? <span style={{ 'color': 'orange' }}>At least one tag is required</span> :
                                            null}
                                </Card.Group>
                            </div>
                        </div>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

export default PracticeViewPaneTags